var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVLo9(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Prima-Versione",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "0 0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ANTICIPO-TFS---DOCUMENTI",
    transform: "translate(-1091 -1891)",
    fillRule: "nonzero",
    stroke: "#FCBB00",
    strokeWidth: 4.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "v_lo_9",
    transform: "translate(1094 1894)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M40.656 57.705L40.656 65.574"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6393443,80 L61.6393443,75.6284153 C61.6393443,70.819672 57.8622932,66.8852459 53.2458996,66.8852459 L28.0655718,66.8852459 C23.4491782,66.8852459 19.6721311,70.819672 19.6721311,75.6284153 L19.6721311,80 L19.6721311,80 L61.6393443,80 Z",
    id: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8032787,28.1967213 L11.8032787,16.1124122 C11.8032787,7.2103043 19.013583,0 27.9156909,0 L52.0843091,0 C60.986417,0 68.1967213,7.2103043 68.1967213,16.1124122 L68.1967213,28.1967213 C68.1967213,43.7854796 55.5887583,56.3934426 40,56.3934426 C24.4112417,56.3934426 11.8032787,43.7854796 11.8032787,28.1967213 Z",
    id: "Vector",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.73531549 33.0743325C2.29412629 28.9422865 0 23.9838317 0 18.1989674 0 12.4141031 4.20589812 7.86885246 9.55885915 7.86885246L12.0441629 7.86885246C11.2794542 9.76959364 10.8970991 11.8769372 10.8970991 14.0669214L10.8970991 26.4630613C10.8970991 30.5951073 11.7000429 34.4792273 13.1147541 38.0327869 10.2470964 37.0410959 7.72355812 35.2229963 5.73531549 33.0743325zM74.2646821 33.0743325C77.7058728 28.9422865 80 23.9838317 80 18.1989674 80 12.4141031 75.7941001 7.86885246 70.4411369 7.86885246L67.9558339 7.86885246C68.720543 9.76959364 69.1029019 11.8769372 69.1029019 14.0669214L69.1029019 26.4630613C69.1029019 30.5951073 68.2999577 34.4792273 66.8852459 38.0327869 69.7529048 37.0410959 72.2764387 35.2229963 74.2646821 33.0743325z",
    id: "Vector",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVLo9);
export default __webpack_public_path__ + "static/media/v_lo_9.6b96be0a6b0fe15a857f1e60d19a353b.svg";
export { ForwardRef as ReactComponent };